import { useEffect, useState } from 'react'
import { usePreferences, useUpdatePreferences, type FocusModeSetting } from '@/features/preferences'
import { DEFAULT_FOCUS, focusActive } from './focus'

/** The person's focus setting (server-saved), whether it is active right now, and a saver. */
export function useFocusMode() {
  const prefs = usePreferences()
  const update = useUpdatePreferences()
  const focus: FocusModeSetting = { ...DEFAULT_FOCUS, ...(prefs.data?.focusMode ?? {}), supportL3: { ...DEFAULT_FOCUS.supportL3, ...(prefs.data?.focusMode?.supportL3 ?? {}) } }
  // Re-render when a timed focus ends, so the UI flips back without a reload.
  const [, tick] = useState(0)
  useEffect(() => {
    if (!focus.enabled || !focus.until) return
    const ms = Date.parse(focus.until) - Date.now()
    if (ms <= 0 || ms > 2 ** 31 - 1) return
    const t = window.setTimeout(() => tick((n) => n + 1), ms + 500)
    return () => window.clearTimeout(t)
  }, [focus.enabled, focus.until])
  const save = (patch: Partial<FocusModeSetting>) => update.mutateAsync({ focusMode: { ...focus, ...patch } })
  return { focus, active: focusActive(focus), save, saving: update.isPending }
}
